module.exports = __webpack_public_path__ + "static/media/summary-final.1d6987be.png";